/* jslint esversion: 6 */
/**
 * Max-width Narrative Content
 *
 * Max-width narrative content to match heading width.
 *
 * @author Dylan James Wagner
 */
const $ = window.jQuery;
const s = {
	$window : $(window),
	$narrativeCardHeading : $('.narrative__card__heading'),
	$narrativeCardContent : $('.narrative__card__content'),
};

function init() {

	$(window).on('load resize', function() {

		if (s.$window.width() >= 768) { // $media-min-width_narrative__cards_flex
			s.$narrativeCardContent.css('max-width', s.$narrativeCardHeading.width());
		}
		else {
			s.$narrativeCardContent.css('max-width', 'none' );
		}
	});
}

export {init as default};
